import React, { useEffect, useState } from "react";
import controllers from "../controllers/partners";
import LoaderData from "../component/LoaderData/LoaderData";
import { useTranslation } from "react-i18next";

const Brand = (props) => {
  const { i18n } = useTranslation();
  const isEnglish = i18n.language === "en";
  const [data, setData] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    const getPartnersList = () => {
      setLoading(true);
      return controllers
        .getPartnersList()
        .then((response) => {
          setData(response);
          setTimeout(() => {
            setLoading(false);
          }, 400);
        })
        .catch((error) => {
          setLoading(false);
          window.location.href = "/500";
        });
    };
    getPartnersList();
  }, []);

  if (loading) {
    return <LoaderData />;
  }

  return (
    <React.Fragment>
      {(!data && !loading) ||
        (data.length === 0 && !loading && (
          <h4
            style={{ textAlign: "center", marginTop: "50px", color: "#c4c4c4" }}
          >
            {isEnglish ? "No Partners found !" : "Aucune Partners  trouvée !"}
          </h4>
        ))}
      <ul className={`brand-list ${props.branstyle}`}>
        {data &&
          data.length > 0 &&
          data.map(({ id, image, link, partner_id }) => (
            <li key={id}>
              <a href={link && link} target="_blank" rel="noreferrer">
                <img
                  src={`${process.env.REACT_APP_DOMAIN}/api/partnersimages/${partner_id}/${image}`}
                  alt="Partner Images"
                />
              </a>
            </li>
          ))}
      </ul>
    </React.Fragment>
  );
};
export default Brand;
